import React, { Component } from 'react';
import { Table, Button, Glyphicon } from 'react-bootstrap/lib';
import Api from './../../../Global/Modules/Api'

const FETCH_URL = "api/educations"
const ACCORD = {
    true: "Ja",
    false: "Nog niet"
}

class KennisOverzicht extends Component {
    constructor() {
        super();
        this.handleDelete = this.handleDelete.bind(this)
        this.handleClick = this.handleClick.bind(this)
        this.getEducations = this.getEducations.bind(this)
        this.handleClickDoc = this.handleClickDoc.bind(this)
        this.state = {
            rows: [],
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0
            },
            currentFetchUrl: FETCH_URL // To know where to fetch (to refresh companies) if a company is deleted
        }
    }
    handleClickDoc(e, t) {
        var url = "api/members/" + e + "/" + t + "/getDiploma";
        Api.GetApiDownload(url)
    }
    // To pass parameters to event handlers while using property initializer syntax, we need to use currying.   
    handleDelete = (type, id) => event => {
        event.preventDefault()
        if (window.confirm('Are you sure you wish to delete this item?')) {
            const FETCH_URL_DELETE = `${FETCH_URL}/${type}/${id}`
            Api.DeleteApi(FETCH_URL_DELETE).then(response => {
                Api.print(`Response delete ${id}`)
                Api.print(response)
                this.getEducations(this.state.currentFetchUrl) // Update the educations list
            })
        }

        else Api.print('Think it better.')

    }
    handleClick(e) {
        const fetchUrl = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        this.getEducations(fetchUrl)
        this.setState({ currentFetchUrl: fetchUrl })
    }
    componentDidMount() {
        this.getEducations(FETCH_URL)
    }

    getEducations(fetchUrl) {
        Api.GetTableApi(fetchUrl, this.handleClick).then(response => {
            Api.print("Response")
            Api.print(response)
            this.setState({ pagination: response.pagination }) // Pagination object 
            return response.data.json() // Data -> companies object
        }).then(data => {
            let rows = data.educations.map((e, index) => {
                return (<tr key={e.id}>
                    <td>{e.type}</td>
                    <td>{e.level}</td>
                    <td>{e.points}</td>
                    <td>{e.institution}</td>
                    <td>{e.name}</td>
                    <td>{e.city}</td>
                    <td>{e.country}</td>
                    <td>{e.yearEnd}</td>
                    <td>{e.hours}</td>
                    <td>{e.diploma == "" || e.diploma == null ? "" : <a onClick={() => this.handleClickDoc(e.id, e.educationType)} target="_blank">bekijk<br /></a>}</td>
                    <td>{e.quantity}</td>
                    <td>{e.description}</td>
                    <td>{ACCORD[e.accord]}</td>
                    <td>
                        <Button bsSize="xsmall" className="delete" onClick={this.handleDelete(e.educationType, e.id)}>
                            <Glyphicon glyph="remove" />
                        </Button>
                    </td>
                </tr >)
            })

            this.setState({ rows: rows })
        })
    }

    render() {
        return (
            <div>
                <div>Resultaten  {(this.state.pagination.pageSize == '0' || this.state.pagination.pageSize > this.state.pagination.totalCount) ? this.state.pagination.totalCount : this.state.pagination.pageSize} van {this.state.pagination.totalCount}</div>
                <Table responsive striped bordered hover>
                    <thead>
                        <tr>
                            <th>type</th>
                            <th>niveau</th>
                            <th>ke's</th>
                            <th>instelling</th>
                            <th>opleiding/functie</th>
                            <th>plaats</th>
                            <th>land</th>
                            <th>jaar</th>
                            <th>uren/jaar</th>
                            <th>diploma/publicatie	</th>
                            <th>aantal</th>
                            <th>beschrijving</th>
                            <th>accoord</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.rows}
                    </tbody>
                </Table>
                <div>
                    <div className="text-left">
                        {this.state.pagination.prevButton}
                    </div>
                    <div className="text-center">
                        Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
                    </div>
                    <div className="text-right">
                        {this.state.pagination.nextButton}
                    </div>
                </div>
            </div>
        );
    }
}

export default KennisOverzicht;


// WEBPACK FOOTER //
// ./src/components/Member/Modules/Kennis/KennisOverzicht.js